<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="add()">新增</Button>
		</div>
		<div class="query">
			<div class="checkbox">

			</div>
			<Input search enter-button placeholder="请输入地址/名称查询" style="width: 500px;" />
		</div>
		<Table border :columns="columns12" :data="data6" :loading="loading">
			<template slot-scope="{ row, index }" slot="action">
				<Button type="primary" size="small" style="margin-right: 5px" @click="update(row.id)">详情</Button>
				<Button @click="forbidden(row.id)" size="small" style="margin-right: 5px" class="delete">禁用/启用</Button>
				<Modal v-model="modal2" width="360">
					<p slot="header" style="color:#f60;text-align:center">
						<Icon type="ios-information-circle"></Icon>
						<span>修改状态</span>
					</p>
					<div style="text-align:center">
						<p>确定修改？</p>
					</div>
					<div slot="footer">
						<Button type="error" size="large" long :loading="modal_loading" @click="updteState()">确定</Button>
					</div>
				</Modal>
			</template>
		</Table>
		<div class="my-page">
			<page :total="total" @updatePage="updatePage" @updateSize="updateSize"></page>
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	export default {
		data() {
			return {
				loading: false,
				total: 0,
				query: { //查询参数
					page: 0,
					size: 10
				},
				modal2: false,
				modal_loading: false,
				deleteId: '',
				columns12: [ {
						title: 'id',
						key: 'id'
					},
					{
						title: '姓名',
						key: 'name'
					},
					{
						title: '联系方式',
						key: 'phone'
					},
					{
						title: '住址',
						key: 'address'
					},
					{
						title: '状态',
						key: 'state',
						render: (h, params) => {
							if (params.row.state == true) {
								return h("div", "启用")
							} else {
								return h("div", "禁用")
							}
						}
					},
					{
						title: '录入时间',
						key: 'createdTime'
					},
					{
						title: '操作',
						slot: 'action',
						width: 300,
						align: 'center'
					}
				],
				data6: [
					/* 	{
						id: '1',
						companyName: '',
						address: '',
						phone1: '',
						phone2: '',
						phone3: '',
						mailbox: '',
						operType: '',
						state: '',
						createdTime: '2010-10-10'

					}, */
				]

			}
		},
		methods: {
			ret() { //返回上一页
				this.$router.go(-1)
			},
			update(id) { //修改
				this.$router.push({
					name: 'adv/emp/update',
					query: {
						id: id
					}
				})
			},
			forbidden(id) {
				this.deleteId = id
				this.modal2 = true
			},
			add() {
				this.$router.push({
					name: 'adv/emp/add'
				})
			},
			updteState() {
				let _this=this
				if (this.deleteId == "") {
					this.$Message.error('参数错误，请刷新页面后重试!');
				} else {
					
					http.http({
					    //这里是你自己的请求方式、url和data参数
					    method: 'post',
					    url: http.url + '/adv/emp/update/state',
					    data: {id: _this.deleteId},
						_this: _this,
						success: function(data) {
							_this.modal_loading = false;
							_this.modal2 = false;
							_this.$Message.success('修改成功！！！');
							_this.ajaxPage()
						}
					    //假设后台需要的是表单数据这里你就可以更改
					  })
					
				}
			},
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			ajaxPage() {
				let _this=this
				this.loading = true
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/adv/emp/page',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						_this.total = data.page.totalElements
						_this.data6 = data.page.content
						
						_this.loading = false
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			}

		},
		components: {
			page
		},
		created() {
			this.ajaxPage();
		}


	}
</script>
<style scoped="scoped">
	.ivu-table-cell {
		padding-left: 0px !important;
	}

	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}

	.my-page {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.ivu-table-cell {
		padding-left: 0px;
	}

	.query {
		display: flex;
		justify-content: space-between;
		margin: 20px 0px 20px 0px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/platform/pcoduction/list.vue